import { Navigate, createFileRoute, useParams } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_account/units/$endCustomerUnitId/')({
  component: IndexRedirect,
});

function IndexRedirect() {
  const { endCustomerUnitId } = useParams({
    strict: false,
  });

  return (
    <Navigate
      to="/units/$endCustomerUnitId/specifications"
      params={{
        endCustomerUnitId: endCustomerUnitId!,
      }}
      replace
    />
  );
}
